import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Placement } from '@popperjs/core';
import { VIEWER_MODE } from './toggle.enum';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss']
})
export class ToggleComponent implements OnInit {
  form!: FormGroup;
  toggleValue!: string;
  toggleNgModel: boolean = false;
  selectedPlacement: Placement = 'bottom';
  public toggleMode2 = VIEWER_MODE.TOGGLE_MODE_2;
  toggleNgModel1: string = VIEWER_MODE.TOGGLE_MODE_1;
  toggleNgModel2: string = VIEWER_MODE.TOGGLE_MODE_1;
  toggleNgModel3: string = VIEWER_MODE.TOGGLE_MODE_1;
  toggleNgModel6: string = VIEWER_MODE.TOGGLE_MODE_1;
  toggleNgModel4: boolean = false;
  toggleNgModel5: string = VIEWER_MODE.TOGGLE_MODE_1;
  public view1: string = 'Book view';
  public view2: string = 'Reader view';
  public role = 'switch';

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(params => {
      this.toggleValue = params['toggle3'];
      this.toggleNgModel5 = params['toggle9'];
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      toggle: [false, Validators.requiredTrue]
    });
  }
}